import React, { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import fundacionNicanImg from "../imgs/Logo_Nican.png";
import "../styles/Header.css";

function Header() {
  const [activeTab, setActiveTab] = useState("home");
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = () => {
    const sections = [
      ["about", "about"],
      ["certificaciones", "certificaciones"],
      ["mapa", "mapa"],
      ["calificaciones", "calificaciones"],
      ["contact", "contact"],
      ["FQA", "FQA"],
    ];

    const scrollPosition = window.scrollY + 120;

    sections.forEach(([tab, sectionId]) => {
      const section = document.getElementById(sectionId);
      if (section && scrollPosition >= section.offsetTop) {
        setActiveTab(tab);
      }
    });
  };

  const handleLinkClick = (tab, sectionId) => {
    setActiveTab(tab);
    setExpanded(false);

    if (location.pathname !== "/") {
      navigate("/", { replace: true });
    }

    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const goToRoute = (path) => {
    setExpanded(false);
    navigate(path);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className="header-navbar"
      expanded={expanded}
    >
      <div className="container header-container">
        <Navbar.Brand href="/" className="header-brand">
          <img src={fundacionNicanImg} alt="Fundación Nican" />
          <span>Fundación Nican</span>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(expanded ? false : "expanded")}
          className="navbar-toggler-custom"
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="header-nav">
            <Nav.Link
              className={`nav-link-custom ${
                activeTab === "about" ? "active" : ""
              }`}
              onClick={() => handleLinkClick("about", "about")}
            >
              Quiénes Somos
            </Nav.Link>
            <Nav.Link
              className={`nav-link-custom ${
                activeTab === "certificaciones" ? "active" : ""
              }`}
              onClick={() =>
                handleLinkClick("certificaciones", "certificaciones")
              }
            >
              Programas
            </Nav.Link>
            <Nav.Link
              className={`nav-link-custom ${
                activeTab === "mapa" ? "active" : ""
              }`}
              onClick={() => handleLinkClick("mapa", "mapa")}
            >
              Sede
            </Nav.Link>
            <Nav.Link
              className={`nav-link-custom ${
                activeTab === "calificaciones" ? "active" : ""
              }`}
              onClick={() => handleLinkClick("calificaciones", "calificaciones")}
            >
              Opiniones
            </Nav.Link>
            <Nav.Link
              className={`nav-link-custom ${activeTab === "FQA" ? "active" : ""}`}
              onClick={() => handleLinkClick("FQA", "FQA")}
            >
              FAQ
            </Nav.Link>
            <Nav.Link className="nav-link-custom" onClick={() => goToRoute("/blog")}>
              Blog
            </Nav.Link>
            <Nav.Link
              className="nav-link-custom nav-link-cta"
              onClick={() => handleLinkClick("contact", "contact")}
            >
              Contacto
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

export default Header;
